export default {
  crmUsers: state => state.crmUsers,
  crmTeams: state => state.crmTeams,
  parentTeams: state => state.parentTeams,
  teamMembers: state => state.teamMembers,
  records: state => state.records,
  dictionaryList: state => state.dictionaryList,
  dictionaryDetailList: state => state.dictionaryDetailList,
  dictionaryDetail: state => state.dictionaryDetail,
  teamConfigList: state => state.teamConfigList,
  secondTeamList: state => state.secondTeamList,
  allCategoryList: state => state.allCategoryList,
  allDictionaryList: state => state.allDictionaryList,
  teamConfigDetail: state => state.teamConfigDetail,
  teamChangeList: state => state.teamChangeList,
  roleList: state => state.roleList,
  roleUserList: state => state.roleUserList,
  menuTreeList: state => state.menuTreeList,
  productList: state => state.productList,
};
